import React from 'react';

const Blogs = () => {
    return (
        <div>
            <h1 className='py-48 text-3xl font-bold text-center border-4 border-black'>Coming soon...</h1>
        </div>
    );
};

export default Blogs;